import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export async function renderPdfFirstPageToDataUrl(pdfUrl, scale = 1.5) {
  // Fetch the PDF as an ArrayBuffer to avoid CORS/data-range issues
  const response = await fetch(pdfUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF: ${response.status}`);
  }
  const arrayBuffer = await response?.arrayBuffer();

  const loadingTask = pdfjsLib?.getDocument({ data: arrayBuffer });
  const pdf = await loadingTask.promise;
  
  // Get total number of pages
  const totalPages = pdf?.numPages;
  
  const page = await pdf?.getPage(1);

  const viewport = page?.getViewport({ scale });
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', { willReadFrequently: true });

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;
  const dataUrl = canvas.toDataURL('image/jpeg', 0.9);

  // cleanup
  canvas.width = 0;
  canvas.height = 0;
  page.cleanup();
  pdf.cleanup();

  return {
    firstPageImage: dataUrl,
    totalPages: totalPages
  };
}

export async function renderPdfAllPagesToDataUrl(pdfUrl, scale = 1.5) {
  // Fetch the PDF as an ArrayBuffer to avoid CORS/data-range issues
  const response = await fetch(pdfUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF: ${response.status}`);
  }
  const arrayBuffer = await response.arrayBuffer();

  const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
  const pdf = await loadingTask.promise;
  // Get total number of pages
  const totalPages = pdf.numPages;
  
  const allPagesImages = [];

  // Render all pages
  for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: context, viewport }).promise;
    const dataUrl = canvas.toDataURL('image/jpeg', 0.9);

    allPagesImages.push(dataUrl);

    // cleanup
    canvas.width = 0;
    canvas.height = 0;
    page.cleanup();
  }

  pdf.cleanup();

  return {
    allPagesImages: allPagesImages,
    totalPages: totalPages
  };
}


